<template>
  <div>
    <CrudList
      title="Respuestas"
      storeName="Answers"
      :canAdd="false"
      :canEdit="false"
      :canDelete="true"
      sortable
      parentStoreName="Options"
    >

    <template v-slot:fullname="{ item }">
      <v-row align="center" justify="center">
        <v-col>
          {{  item.user_id ? (item.user_id.name || '' +  item.user_id.last_name || '') : '' }}
        </v-col>
      </v-row>
    </template>

    <template v-slot:created_at="{ item }">
      <v-row align="center" justify="center">
        <v-col>
          {{ item.created_at }}
        </v-col>
      </v-row>
    </template>

    <template v-slot:has_spots="{ item }">
      <v-row align="center" justify="center">

        {{ item.user_id.color_spot == 'grey' || item.user_id.color_spot == 'green'? 'SI':'NO' }}

      </v-row>
    </template>

    </CrudList>
  </div>
</template>

<script>
  import CrudList from "@/components/Crud/CrudList";

  export default {
    components: {CrudList},
    data: () => ({
      offsetTop: 0,
    }),
    methods: {
      onScroll (e) {
        this.offsetTop = e.target.scrollTop
      },

    },
  };
</script>
